import React from "react"
import Helmet from "react-helmet"

import Navbar from "./navbar";
import Footer from "./footer";

// Gradient map used by the .duo class: plum shadows, bordeaux mids, pale rose highlights.
const DuotoneFilter = () => (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
        <filter id="menru-duotone" colorInterpolationFilters="sRGB">
            <feColorMatrix type="saturate" values="0"/>
            <feComponentTransfer>
                <feFuncR type="linear" slope="1.4" intercept="-0.2"/>
                <feFuncG type="linear" slope="1.4" intercept="-0.2"/>
                <feFuncB type="linear" slope="1.4" intercept="-0.2"/>
            </feComponentTransfer>
            <feComponentTransfer>
                <feFuncR type="table" tableValues="0.14 0.58 0.99"/>
                <feFuncG type="table" tableValues="0.02 0.16 0.94"/>
                <feFuncB type="table" tableValues="0.08 0.35 0.96"/>
            </feComponentTransfer>
        </filter>
    </svg>
)

export const Layout = (props) => {
    return (
        <div>
            <Helmet htmlAttributes={{ lang: "fr" }}>
                <title>Bagad Men Ru</title>
                <meta name="description" content="Bagad Men Ru, ensemble traditionnel breton de Montfort-sur-Meu : actualités, vidéos, école de musique et contact."/>
                <meta name="theme-color" content="#121012"/>
            </Helmet>
            <DuotoneFilter/>
            <Navbar/>
            <main>{props.children}</main>
            <Footer/>
        </div>
    )
}
